import {TypeConstant} from "./TypeConstant";

export const Name = (name) => {

    return {
        type: TypeConstant.Name,
        payload:name
    }

}

export const Email = (email) => {
    return {
        type: TypeConstant.Email,
        payload: email
    }
}
export const JobTitle = (jobTitle)=>{
    return {
        type: TypeConstant.JobTitle,
        payload: jobTitle
    }
}

export const Department = (department)=>{
    return {
        type: TypeConstant.Department,
        payload: department
    }
}

export const Mobile = (mobile)=>{
    return {
        type: TypeConstant.Mobile,
        payload: mobile
    }
}
export const Website = (website)=>{
    return {
        type: TypeConstant.WebSite,
        payload: website
    }
}

export const ImageLogo = (image)=>{
    return {
        type: TypeConstant.Image,
        payload: image
    }
}

export const ShowAiYearLogo = (show)=>{
    return {
        type: TypeConstant.ShowAiYearLogo,
        payload: show
    }
}

export const Linkedin = (linkedin)=>{
    return {
        type: TypeConstant.Linkedin,
        payload: linkedin
    }
}

export const Twitter = (twitter)=>{
    return {
        type: TypeConstant.Twitter,
        payload: twitter
    }
}

export const Facebook = (facebook)=>{
    return {
        type: TypeConstant.Facebook,
        payload: facebook
    }
}

export const Github = (github)=>{
    return {
        type: TypeConstant.Github,
        payload: github
    }
}

export const Ar_Name = (name) => {

    return {
        type: TypeConstant.Ar_Name,
        payload:name
    }

}

export const Ar_JobTitle = (jobTitle)=>{
    return {
        type: TypeConstant.Ar_JobTitle,
        payload: jobTitle
    }
}

export const Ar_Department = (department)=>{
    return {
        type: TypeConstant.Ar_Department,
        payload: department
    }
}

export const Ar_Email = (email) => {

    return {
        type: TypeConstant.Ar_Email,
        payload:email
    }

}

export const Ar_Mobile = (mobile)=>{
    return {
        type: TypeConstant.Ar_Mobile,
        payload: mobile
    }
}

export const Ar_Website = (website)=>{
    return {
        type: TypeConstant.Ar_Website,
        payload: website
    }
}

export const LanguageStyle = (lang)=>{
    return {
        type: TypeConstant.Language,
        payload: lang
    }
}

export const LanguageWeb = (lang)=>{
    return {
        type: "LANGUAGE_WEB",
        payload: lang
    }
}

export const Flag = (flag) => {
    return {
        type: 'FLAG',
        payload:flag

    }
}


export const toggleTour = (the_state) => {
    return {
        type: 'TOUR',
        payload: the_state
    }
}